import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { InstitutionListedCompany } from '@/features/institution/schemas/listed-company';

type InstitutionFieldsListedCompanyProps = {
  isNameAsked: boolean;
  isMicRequired?: boolean;
  micDescription: string;
};

const InstitutionFieldsListedCompany = ({ isNameAsked, isMicRequired = false, micDescription }: InstitutionFieldsListedCompanyProps) => {
  const form = useFormContext<{ listedCompany: InstitutionListedCompany }>();
  const { t } = useTranslation();

  return (
    <>
      {isNameAsked ? (
        <FormField
          control={form.control}
          name="listedCompany.name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('institutionDetails.ownership.listing.name')}*</FormLabel>
              <FormControl>
                <Input {...field} placeholder={t('institutionDetails.ownership.listing.placeholders.name')} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
      <FormField
        control={form.control}
        name="listedCompany.mic"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t('institutionDetails.ownership.listing.mic')}
              {isMicRequired ? '*' : null}
            </FormLabel>
            <FormDescription>{micDescription}</FormDescription>
            <FormControl>
              <Input {...field} autoCapitalize="characters" placeholder={t('institutionDetails.ownership.listing.placeholders.mic')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="listedCompany.ticker"
        // Either identifier clears the other's error, so a change to one rechecks both
        rules={{ deps: ['listedCompany.isin'] }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.ownership.listing.ticker')}</FormLabel>
            <FormDescription>{t('institutionDetails.ownership.listing.identifiersDescription')}</FormDescription>
            <FormControl>
              <Input {...field} autoCapitalize="characters" placeholder={t('institutionDetails.ownership.listing.placeholders.ticker')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="listedCompany.isin"
        rules={{ deps: ['listedCompany.ticker'] }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.ownership.listing.isin')}</FormLabel>
            <FormDescription>{t('institutionDetails.ownership.listing.isinDescription')}</FormDescription>
            <FormControl>
              <Input {...field} autoCapitalize="characters" placeholder={t('institutionDetails.ownership.listing.placeholders.isin')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
InstitutionFieldsListedCompany.displayName = 'InstitutionFieldsListedCompany';

export { InstitutionFieldsListedCompany };
